export default __webpack_public_path__ + "static/media/4.bb40d6a9.png";